import { render, staticRenderFns } from "./transfer-warehouse-view.vue?vue&type=template&id=5ff2591c&scoped=true&"
import script from "./transfer-warehouse-view.vue?vue&type=script&lang=ts&"
export * from "./transfer-warehouse-view.vue?vue&type=script&lang=ts&"
import style0 from "./transfer-warehouse-view.vue?vue&type=style&index=0&id=5ff2591c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2591c",
  null
  
)

export default component.exports